<div class="flex-auto bg-card">

    <!-- Header -->
        <div class="flex flex-row  justify-between items-center py-3 px-8 border-b">

            <!-- Title -->
            <div>
                <div class="ml-0.5 text-secondary text-4xl font-bold"> Usuario(s)</div>
            </div>

            <button
                *appControlAcceso="'lectura'"
                class="ml-4"
                mat-flat-button
                [color]="'primary'"
                (click)="openAgregarUsuario()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">Agregar</span>
            </button>

        </div>

        <!-- Listado de usuarios agrupado por estado -->
        <div *ngFor="let grupo of usuariosPorEstado">
            <div
                class="text-secondary sticky top-0 z-10 -mt-px border-b border-t bg-gray-50 px-6 py-1 font-medium uppercase dark:bg-gray-900 md:px-8">
                {{ grupo.titulo }}
            </div>

            <table mat-table [dataSource]="grupo.lista" class="w-full">
                <!-- Usuario Column -->
                <ng-container matColumnDef="usuario">
                    <th mat-header-cell *matHeaderCellDef class="hidden"></th>
                    <td mat-cell *matCellDef="let usuario" class="px-6 md:px-8">
                        <div class="flex items-center py-3">
                            <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                <span class="text-sm font-semibold">{{ getInicial(usuario.nombreCompleto) }}</span>
                            </div>
                            <div class="ml-4 min-w-[180px]">
                                <div class="font-medium leading-5 text-gray-800">
                                    <span>{{ usuario.nombreCompleto }}</span>
                                    <span class="ml-2 text-[11px] font-semibold text-white bg-blue-500 rounded px-2 py-0.5 align-middle">{{ usuario.rol.descripcion | titlecase }}</span>
                                </div>
                                <div class="text-sm leading-5 truncate text-secondary">{{ usuario.email }}</div>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- dependencia Column -->
                <ng-container matColumnDef="dependencia">
                    <th mat-header-cell *matHeaderCellDef class="hidden"></th>
                    <td mat-cell *matCellDef="let usuario" class="w-full">
                        <app-chip [text]="usuario?.dependencia?.descripcion"></app-chip>
                    </td>
                </ng-container>

                <!-- Acciones Column -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef class="hidden"></th>
                    <td mat-cell *matCellDef="let usuario" class="text-right pr-4">
                        <button *appControlAcceso="'lectura'"
                            mat-icon-button [matMenuTriggerFor]="menu" aria-label="acciones usuario">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button (click)="openEditarUsuario(usuario)" mat-menu-item>
                                <mat-icon>edit</mat-icon>
                                <span>Actualizar</span>
                            </button>
                            <button (click)="openConfirmarEstadoUsuario(usuario)" mat-menu-item>
                                <mat-icon>
                                    {{ isUsuarioActivo(usuario) ? 'person_off' : 'person' }}
                                </mat-icon>
                                <span>
                                    {{ isUsuarioActivo(usuario) ? 'Inactivar usuario' : 'Activar usuario' }}
                                </span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="hidden"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b hover:bg-gray-50"></tr>
            </table>
        </div>

</div>
